module.exports = __webpack_public_path__ + "static/dosBicicletasAzules-66fe09585b0a5e0be33ebb82831f8c4c.png";